import React, { useEffect, useState } from 'react';
import './Toast.css';

function Toast({ message, onDismiss }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (message) {
            setVisible(true);
            let duration = 4000;
            if (message.type === 'error') duration = 8000;
            else if (message.type === 'warning') duration = 12000;
            const timer = setTimeout(() => {
                setVisible(false);
                setTimeout(onDismiss, 300); // wait for slide-out animation
            }, duration);
            return () => clearTimeout(timer);
        } else {
            setVisible(false);
        }
    }, [message, onDismiss]);

    if (!message) return null;

    const handleDismiss = () => {
        setVisible(false);
        setTimeout(onDismiss, 300);
    };

    return (
        <div className={`toast-container ${visible ? 'toast-visible' : 'toast-hidden'}`}>
            <div className={`toast toast-${message.type}`}>
                <div className="toast-content">
                    <span className="toast-icon">
                        {message.type === 'error' ? '❌'
                            : message.type === 'success' ? '✅'
                            : message.type === 'warning' ? '⚠️'
                            : 'ℹ️'}
                    </span>
                    <span className="toast-text">{message.text}</span>
                </div>
                <button className="toast-dismiss" onClick={handleDismiss}>×</button>
            </div>
        </div>
    );
}

export default Toast;
